/**
 * Post report categories shown in Report post modal.
 * Aligns with Apple App Review Guideline 1.2 (UGC moderation themes).
 *
 * Keep server ALLOWED_CODES in sync: server/constants/postReportReasons.js
 */

export const POST_REPORT_REASON_OPTIONS = [
  { code: 'spam_scams', label: 'Spam, scams, or misleading content' },
  { code: 'harassment_bullying', label: 'Harassment or bullying' },
  { code: 'hate_discrimination', label: 'Hate speech or discrimination' },
  { code: 'violence_threats', label: 'Violence, graphic harm, or threats' },
  { code: 'sexual_explicit', label: 'Sexually explicit material' },
  { code: 'self_harm_dangerous', label: 'Self-harm, suicide, or dangerous activities' },
  { code: 'child_safety', label: 'Child safety concerns' },
  { code: 'illegal_goods', label: 'Illegal activity or regulated goods' },
  { code: 'ip_impersonation', label: 'Impersonation, fraud, copyright, or trademark issue' },
  { code: 'age_rating', label: "Content may exceed this app's age rating" },
  { code: 'other', label: 'Something else' },
];

export const REPORT_OTHER_REASON_CODE = 'other';

/** Must match POST_REPORT_OTHER_MIN_DETAILS_LENGTH on the server when reason is other. */
export const REPORT_OTHER_MIN_DETAILS_LENGTH = 10;
